// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {
  getFirestore,
  where,
  collection,
  query,
  getDocs,
} from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAUVXZfluN0uXd3HB7focwQ_gT3UQNdpJE",
  authDomain: "melos-church.firebaseapp.com",
  projectId: "melos-church",
  storageBucket: "melos-church.appspot.com",
  messagingSenderId: "584060305090",
  appId: "1:584060305090:web:b34852f7cd16231522c55b",
  measurementId: "G-C1BBP215RL",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage();

const churchRef = collection(db, "church");

const bannedPaths = [
  'admin',
  'blog',
  'api',
  'auth',
  '404',
  'integrations',
  'privacy',
  'sign-in',
  'sign-up',
  'terms',
  'verify-email',
  'dashboard',
  'login',
  'signup',
  'logout',
  'settings',
  'account',
  'user',
  'profile',
  'password',
  'email',
  'creditcard',
  'payment',
  'private',
  'secret',
  'api',
  'wp-admin',
  'wp-content',
  'wp-includes',
  'cgi-bin',
  '80',
  '443',
  '22',
  '21',
  '3306',
  '5432',
  '.php',
  '.cgi',
  '.asp',
  '.aspx',
  '.exe',
  '.dll',
  '.sh',
  'index',
  'error',
  '404',
  'robots.txt',
  'sitemap.xml',
  'favicon.ico',
  'javascript:',
  'data:',
  'blob:',
  '&',
  '?',
  '#',
  '/',
  '.',
  ':'
];

function isPathBanned(inputPath) {
  return bannedPaths.includes(inputPath);
}

export async function doesChurchPathExist(slug) {
  if (isPathBanned(slug)) {
    return true;
  }

  // Query the database for a church with the provided slug
  const q = query(churchRef, where("slug", "==", slug));
  const querySnapshot = await getDocs(q);

  // Check if a church with the slug exists
  if (querySnapshot.size > 0) {
    // Church with the slug exists
    return true;
  }

  return false;
}

function getDomainFromSubdomain() {
  const hostname = window.location.hostname; // Get the full hostname

  // Split the hostname into an array of parts
  const parts = hostname.split(".");

  // If there are at least two parts, it means we have a subdomain and domain
  if (parts.length >= 2) {
    const domain = parts.slice(-2).join("."); // Join the last two parts to get the domain
    return domain;
  } else {
    return ''; // No subdomain found
  }
}

function isAllowedDomain() {
  const allowedDomains = ["localhost", "melos.church", "gitpod.io"]; // List of allowed domains
  const currentDomain = getDomainFromSubdomain();

  return allowedDomains.includes(currentDomain);
}

export async function handleImageUpload(
  file: File,
  filename: string,
): Promise<string> {
  if (!isAllowedDomain()) {
    throw new Error("Image upload was not allowed");
  }

  const storageRef = ref(
    storage,
    "images/" + filename + "." + file.type.split("/")[1],
  );

  // Upload the image to Firebase
  await uploadBytes(storageRef, file);

  const imageDownloadURL = await getDownloadURL(storageRef);

  // Return the image reference URL
  return imageDownloadURL;
}
